import { replaceBaseOrigin } from './replaceBaseOrigin';
import { setOriginUrl } from './setOriginUrl';

/**
 *
 * @param originUrl import env from '@env' 객체의 KC_IAM_ENDPOINT 값을 전달합니다. server side 일 때에도 올바른 경로로 보내기 위한 대체 주소로 활용합니다. (미설정 시, server side의 origin은 빈 문자열로 반환됩니다.)
 * @param subdomain 사용할 3차 domain을 지정할 수 있습니다. 없으면 'account'를 기본값으로 사용합니다.
 * @returns protocol://(local|account|console|iam).subdomain -> protocol://account.subdomain 으로 치환된 값을 반환합니다.
 */
function getAccountBaseUrl(originUrl?: string, subdomain?: string) {
  const baseOrigin = setOriginUrl(originUrl);

  // http://, https:// 와 무관하게 local, account, console, iam 키워드를 account 키워드로 수정
  return replaceBaseOrigin(baseOrigin, subdomain || 'account');
}

export default getAccountBaseUrl;
